import React from 'react';
import {PageHeader} from "../../../components/shared/PageHeader/PageHeader";
import {LoadingErrorBlock} from "../../../components/shared/LoadingErrorBlock";
import {useParams} from "react-router-dom";
import {useFetchFeedback} from "../../../hooks/useQuery/useFetchFeedback";
import style from "./FeedbackPage.module.css";
import {API_URL_V2} from "../../../config";
import FsLightbox from "fslightbox-react";

interface FeedbackPageDetailProps {
    props?: string;
}

export const FeedbackPageDetail: React.FC<FeedbackPageDetailProps> = ({props}) => {
    const {feedbackId} = useParams();
    const {fbsData, fbsError, fbsIsLoading} = useFetchFeedback(feedbackId);

    const [lightboxController, setLightboxController] = React.useState<{
        toggler: boolean;
        slide: number
    }>({toggler: false, slide: 1});
    const images: string[] = fbsData?.filesPath?.map((file: string) => `${API_URL_V2}/uploads/${file}`) || [];
    const openLightboxOnSlide = (slide: number) => {
        setLightboxController({toggler: !lightboxController.toggler, slide});
    };
    return (
        <>
            <PageHeader
                title={fbsData?.about || "Обратная связь"}
                isAdmin={true}
                enabledBackBtn={false}
                enabledBreadcrumbs={false}
                buttons={
                    <></>
                }
            />
            <LoadingErrorBlock
                isLoading={fbsIsLoading}
                isError={Boolean(fbsError)}
                errorMessage="Ошибка загрузки обратной связи. Пожалуйста, попробуйте позже."
            />
            {(fbsData && !fbsError && !fbsIsLoading) && (
                <div className={style.table  + " " + style.tableDetail}>
                    <div className={style.tableRow + " " + style.tableFirst}>
                        {fbsData.about}
                    </div>
                    <div className={style.tableRow}>
                        <p className={style.tableCellKey}>
                            ФИО
                        </p>
                        <div className={style.tableCellValue}>
                            {fbsData?.ownerInfo?.full_name}
                        </div>
                    </div>
                    <div className={style.tableRow}>
                        <p className={style.tableCellKey}>
                            Дата и время
                        </p>
                        <p className={style.tableCellValue}>
                            {fbsData?.formattedDate}
                        </p>
                    </div>
                    <div className={style.tableRow}>
                        <p className={style.tableCellKey}>
                            Тема обращения
                        </p>
                        <p className={style.tableCellValue}>
                            {fbsData?.about}
                        </p>
                    </div>
                    <div className={style.tableRow}>
                        <p className={style.tableCellKey}>
                            Текст обращения
                        </p>
                        <p className={style.tableCellValue}>
                            {fbsData?.text}
                        </p>
                    </div>
                    <div className={style.tableRow}>
                        <p className={style.tableCellKey}>
                            Контакты
                        </p>
                        <p className={style.tableCellValue}>
                            {fbsData?.contact}
                        </p>
                    </div>

                    {(fbsData?.filesPath && fbsData?.filesPath.length >= 1) && (
                        <div className={style.tableRow}
                        >
                            <p className={style.tableCellKey}>
                                Прикрепленные изображения
                            </p>
                            <div className={style.tableCellValue}>
                                <div style={{display: 'flex', gap: 12, flexWrap: 'wrap'}}>
                                    {images.map((src, idx) => (
                                        <img
                                            key={src}
                                            src={src}
                                            alt={`Изображение ${idx + 1}`}
                                            style={{
                                                width: 100,
                                                cursor: "pointer",
                                                borderRadius: 6,
                                                boxShadow: "0 1px 4px #0002"
                                            }}
                                            onClick={() => openLightboxOnSlide(idx + 1)}
                                        />
                                    ))}
                                </div>
                                <FsLightbox
                                    toggler={lightboxController.toggler}
                                    sources={images}
                                    slide={lightboxController.slide}
                                />
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    )
};